import { useState } from "react";
import { Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";
import { nowTime, parseAmount } from "@/lib/utils2";

const KINDS = [
  { id: "contanti", label: "Contanti", cls: "bg-emerald-600 text-white border-emerald-600" },
  { id: "pos", label: "POS", cls: "bg-sky-600 text-white border-sky-600" },
  { id: "spesa", label: "Spesa", cls: "bg-red-600 text-white border-red-600" },
];

export function CashEntryForm({ date, onAdded }) {
  const [amount, setAmount] = useState("");
  const [kind, setKind] = useState("contanti");
  const [note, setNote] = useState("");
  const [time, setTime] = useState(nowTime);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const value = parseAmount(amount);
    if (!value || value <= 0) {
      toast.error("Inserisci un importo valido");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/cash", { date, time, kind, amount: value, note });
      onAdded(data);
      setAmount("");
      setNote("");
      setTime(nowTime());
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="rounded-2xl bg-white border border-[var(--border)] p-4 sm:p-5 space-y-4" data-testid="cash-entry-form">
      <div className="grid grid-cols-3 gap-2" role="radiogroup">
        {KINDS.map((k) => (
          <button type="button" key={k.id} onClick={() => setKind(k.id)} data-testid={`cash-kind-${k.id}`} aria-pressed={kind === k.id}
            className={`h-11 rounded-xl border text-sm font-semibold transition-colors ${kind === k.id ? k.cls : "bg-white text-[var(--muted)] border-[var(--border)]"}`}>
            {k.label}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-[1fr_130px] sm:grid-cols-[160px_1fr_130px_auto] gap-2">
        <Input inputMode="decimal" placeholder="Importo €" value={amount} onChange={(e) => setAmount(e.target.value)} className="h-12 text-lg font-mono" data-testid="cash-amount-input" autoFocus />
        <Input type="time" value={time} onChange={(e) => setTime(e.target.value)} className="h-12 sm:order-3" data-testid="cash-time-input" />
        <Input placeholder={kind === "spesa" ? "es. Sicurezza uscita" : "Nota (es. abbigliamento)"} maxLength={200} value={note} onChange={(e) => setNote(e.target.value)} className="h-12 col-span-2 sm:col-span-1 sm:order-2" data-testid="cash-note-input" />
        <button className="btn-primary h-12 px-5 col-span-2 sm:col-span-1 sm:order-4" disabled={busy} data-testid="cash-add-button">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Plus className="h-5 w-5" />} Aggiungi
        </button>
      </div>
    </form>
  );
}
